var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.6vw",
    height: "1.6vw",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#262626"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_634_2217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.3125 9.09862V12.4592C8.31242 12.5637 8.35371 12.6639 8.42734 12.7381L15.1457 19.4564C15.2935 19.6035 15.4936 19.6861 15.7022 19.6861C15.9107 19.6861 16.1108 19.6035 16.2586 19.4564L19.4578 16.2572C19.6049 16.1094 19.6875 15.9093 19.6875 15.7008C19.6875 15.4922 19.6049 15.2922 19.4578 15.1443L12.7422 8.4287C12.668 8.35507 12.5678 8.31378 12.4633 8.31386H9.1C8.99667 8.31335 8.89427 8.33329 8.79867 8.37251C8.70308 8.41174 8.61619 8.46948 8.543 8.54242C8.46981 8.61535 8.41176 8.70205 8.3722 8.7975C8.33265 8.89296 8.31236 8.9953 8.3125 9.09862Z",
    stroke: "#FCFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.375 10.5C11.375 10.6731 11.3237 10.8422 11.2275 10.9861C11.1314 11.13 10.9947 11.2422 10.8348 11.3084C10.675 11.3746 10.499 11.3919 10.3293 11.3582C10.1596 11.3244 10.0037 11.2411 9.88128 11.1187C9.75891 10.9963 9.67558 10.8404 9.64181 10.6707C9.60805 10.501 9.62538 10.325 9.69161 10.1652C9.75783 10.0053 9.86998 9.86861 10.0139 9.77246C10.1578 9.67632 10.3269 9.625 10.5 9.625C10.7321 9.625 10.9546 9.71719 11.1187 9.88128C11.2828 10.0454 11.375 10.2679 11.375 10.5Z",
    fill: "#FCFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_634_2217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "matrix(0 -1 1 0 7 21)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.4af26d467b32e7de46fe5b106c4f1271.svg";
export { ForwardRef as ReactComponent };